import { Card, Stack, Title } from '@mantine/core'
import {
  TDownlinkMessagesList,
  useGetDownlinkMessagesByDevice,
} from 'api/loraDevices/getDownlinkMessages'
import { QueryPaginated } from 'components/common'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { DownlinkMessageTable } from './DownlinkMessageTable'

export const DownlinkHistory = ({
  deviceModelId,
}: {
  deviceModelId: string
}) => {
  const { deviceId } = useParams()
  const { t } = useTranslation()
  const query = useGetDownlinkMessagesByDevice(deviceId)

  return (
    <Card>
      <Stack>
        <Title order={4}>{t('loraDevices.pastDownlinkMessages')}</Title>
        <QueryPaginated.Wrapper query={query}>
          <QueryPaginated.Data>
            {(data: TDownlinkMessagesList) => (
              <DownlinkMessageTable data={data} deviceModelId={deviceModelId} />
            )}
          </QueryPaginated.Data>
          <QueryPaginated.NoData
            title={t('loraDevices.noPastDownlinkMessagesFound')}
          />
        </QueryPaginated.Wrapper>
      </Stack>
    </Card>
  )
}
